// extracted by mini-css-extract-plugin
export default {"root":"EditLicenceForm_root__+hQjl","readOnly":"EditLicenceForm_readOnly__LDLT3","quantity":"EditLicenceForm_quantity__7ZE1P","submitBtn":"EditLicenceForm_submitBtn__UgFN9"};